import { render } from "./CheckoutFAQ.vue?vue&type=template&id=0a4a7a9a&scoped=true"
import script from "./CheckoutFAQ.vue?vue&type=script&lang=js"
export * from "./CheckoutFAQ.vue?vue&type=script&lang=js"

import "./CheckoutFAQ.vue?vue&type=style&index=0&id=0a4a7a9a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4a7a9a"]])

export default __exports__